import ExtendableObject from "./ExtendableObject";

const UploaderViewMode = ExtendableObject.extend(
  /** @lends UploaderViewMode.prototype */
  {
    /**
     * A mode of an UploaderView operation.
     *
     * A view holds an instance of a mode and calls its methods when a user input
     * is made. The mode in return calls the views methods to handle the action.
     *
     * @param {UploaderView} view
     * @constructs
     */
    constructor(view) {
      /**
       * The view this mode is of (is it english?)
       * @type {UploaderView}
       */
      this.view = view;
    },

    /**
     * The mode was entered
     */
    modeEnter() {},

    /**
     * The mode is about to be left
     */
    modeLeave() {},

    /**
     * Add button clicked
     */
    add() {},

    /**
     * Capture button clicked
     */
    capture() {},

    /**
     * Drag operation initiated
     * @param {object} evt - event to be forwarded to the view
     */
    drag(evt) {},

    /**
     * Files dropped
     * @param {Event} evt - event to be forwarded to the view
     */
    drop(evt) {},

    /**
     * Item clicked
     * @param evt
     */
    click(evt) {}
  });
//=============================================================================
/**
 * Default mode - drag reorders items, drop adds files etc.
 * @constructor
 * @extends UploaderViewMode
 */
export const DefaultMode = UploaderViewMode.extend(
  /** @lends DefaultMode.prototype */
  {
    add() { this.view.openFileInput(); },

    capture() { this.view.capturePhoto(); },

    drag(evt) { this.view.initDrag(evt); },

    drop(evt) { this.view.handleSelect(evt); },

    // click(evt) {}
  });